export const Dashboard = () => {
    return (
      <div className="al-dashboard-page animate__animated animate__fadeIn">
        DASHBOARD
      </div>
    );
}